import { render, staticRenderFns } from "./producto.buscador.multiple.vue?vue&type=template&id=2d1e1ab2&scoped=true&"
import script from "./producto.buscador.multiple.vue?vue&type=script&lang=js&"
export * from "./producto.buscador.multiple.vue?vue&type=script&lang=js&"
import style0 from "./producto.buscador.multiple.vue?vue&type=style&index=0&id=2d1e1ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1e1ab2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VFadeTransition,VIcon,VListItemContent,VListItemSubtitle,VListItemTitle,VTextField})
